export const locale = {
    lang: 'en',
    data: {
        HEADER: {
            'MEGA_MENU': 'Année scolaire',
        },
        SIDENAV: {
            DASHBOARDS: 'Dashboards',
            MAILBOX: 'Mailbox',
            CHAT: 'Chat',
            KNOWLADGE_BASE: 'Knowledge Base',
            CALENDAR: 'Calendar',
            CONTACTS: 'Contacts',
        },
    }
};
